import { useEffect, useState } from 'react';

const QUERY = '(max-width: 767px)';

const hasMatchMedia = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * True when the viewport is phone-width (< 768px). Subscribes to the media
 * query's `change` event so it re-evaluates on resize/rotate. SSR / no-matchMedia
 * environments default to false (desktop) so the app behaves as today.
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    hasMatchMedia() ? window.matchMedia(QUERY).matches : false
  );

  useEffect(() => {
    if (!hasMatchMedia()) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    // Resync in case the viewport changed between the initial render and this effect.
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};
